const cutWalletAddress = (wallet, precision = 5) =>
  `${wallet.substring(0, precision)}...${wallet.slice(wallet.length - precision)}`;

export default cutWalletAddress;
